import React, { useEffect, useState } from 'react'

const withCrisp = (f) => {
  if (window.$crisp) {
    f(window.$crisp)
  }
}

const attributes = {
  chatUnreadCount: 'chat:unread:count',
  chatHidden: 'chat:hidden',
}

const actions = {
  chatToggle: 'chat:toggle',
  chatHide: 'chat:hide',
  chatShow: 'chat:show',
}

const events = {
  chatHidden: 'chat:hidden',
  chatClosed: 'chat:closed',
  chatOpened: 'chat:opened',
  messageReceived: 'message:received',
}

const isCrisp = ($crisp, attribute) =>
  $crisp && $crisp.is && $crisp.is(attribute)

const getCrisp = ($crisp, attribute) =>
  $crisp && $crisp.get && $crisp.get(attribute)

const doCrisp = ($crisp, action) => $crisp.push(['do', action])
const onCrisp = ($crisp, event, callback) =>
  $crisp.push(['on', event, callback])
const offCrisp = ($crisp, event) => $crisp.push(['off', event])

export const useCrisp = () => {
  const [hasUnreadMessage, setHasUnreadMessage] = useState(false)

  const handleToggleChat = () => {
    withCrisp(($crisp) => {
      if (isCrisp($crisp, attributes.chatHidden))
        doCrisp($crisp, actions.chatShow)
      else doCrisp($crisp, actions.chatHide)

      doCrisp($crisp, actions.chatToggle)
    })
  }

  useEffect(() => {
    withCrisp(($crisp) => {
      // Disabling the hide for crisp chat when it is closed
      // onCrisp($crisp, events.chatClosed, () => {
      //   return doCrisp($crisp, actions.chatHide)
      // })
      const updateUnreadMessage = () => {
        setHasUnreadMessage(getCrisp($crisp, attributes.chatUnreadCount) > 0)
      }
      onCrisp($crisp, events.chatOpened, updateUnreadMessage)
      onCrisp($crisp, events.messageReceived, updateUnreadMessage)
      updateUnreadMessage()
    })
    return () => {
      withCrisp(($crisp) => {
        offCrisp($crisp, events.chatClosed)
        offCrisp($crisp, events.chatOpened)
        offCrisp($crisp, events.messageReceived)
      })
    }
  }, [setHasUnreadMessage])

  return { hasUnreadMessage, handleToggleChat }
}

export const CrispContext = React.createContext({})

export const CrispProvider = ({ children }) => {
  const values = useCrisp()
  return (
    <CrispContext.Provider value={values}>{children}</CrispContext.Provider>
  )
}
